import FootballState from "../../../../state/football-state";
import PassAttemptStats from "../../../offensive/pass/attempt/pass-attempt-stats";

export default class FieldGoalFakePassAttemptStats extends PassAttemptStats {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalFakePass;
    }
}
